import React from 'react';
import {
  CALCULATED_REACH_POSTS,
  DUMMY_STATISTICS,
  IMPRESSIONS_POSTS,
  REACH_POSTS,
  REACTIONS_POSTS,
} from 'app/modules/insights/components/demoViews/dummy';
import MetricHeader from 'app/modules/insights/modules/postsPerformance/components/MetricHeader';
import SimpleGrid from 'app/components/SimpleGrid';
import StandardPostPreview from 'app/modules/insights/components/StandardPostPreview';
import { getMedalRankFromIndex } from 'app/modules/insights/utils/getMedalRankFromIndex';
import { colors } from '@kontentino/ui';
import { faBullseyeArrow } from '@fortawesome/pro-regular-svg-icons/faBullseyeArrow';
import { faBullseyePointer } from '@fortawesome/pro-regular-svg-icons/faBullseyePointer';
import { faEye } from '@fortawesome/pro-regular-svg-icons/faEye';
import { faFaceSmileRelaxed } from '@fortawesome/pro-regular-svg-icons/faFaceSmileRelaxed';
import BlockGrid from 'app/components/BlockGrid';
import StatisticCard from 'app/modules/insights/modules/postsPerformance/components/pageStatistics/StatisticCard';

const PostPerformanceDemoView = () => {
  return (
    <div>
      <div className="tw-mb-12">
        <BlockGrid gap={16} columns={4}>
          {DUMMY_STATISTICS.map((statistic) => (
            <StatisticCard key={statistic.name} {...statistic} />
          ))}
        </BlockGrid>
      </div>
      <div className="tw-flex tw-flex-col tw-gap-12">
        <div>
          <div className="tw-mb-6 tw-flex tw-items-center">
            <MetricHeader
              metric={{
                key: 'totalReachUnique',
                title: 'Reach',
                color: colors.primary.default,
                icon: faBullseyeArrow,
              }}
            />
          </div>
          <SimpleGrid columns={3} gap={16} className="tw-mb-4">
            {REACH_POSTS.map((post, index) => (
              <StandardPostPreview
                key={index}
                {...post}
                medalRank={getMedalRankFromIndex(index)}
                classNames={{
                  root: 'tw-h-[432px] tw-w-full',
                }}
              />
            ))}
          </SimpleGrid>
        </div>
        <div>
          <div className="tw-mb-6 tw-flex tw-items-center">
            <MetricHeader
              metric={{
                key: 'postImpressionsUnique',
                title: 'Calculated reach',
                color: colors.success.default,
                icon: faBullseyePointer,
              }}
            />
          </div>
          <SimpleGrid columns={3} gap={16} className="tw-mb-4">
            {CALCULATED_REACH_POSTS.map((post, index) => (
              <StandardPostPreview
                key={index}
                {...post}
                medalRank={getMedalRankFromIndex(index)}
                classNames={{
                  root: 'tw-h-[432px] tw-w-full',
                }}
              />
            ))}
          </SimpleGrid>
        </div>
        <div>
          <div className="tw-mb-6 tw-flex tw-items-center">
            <MetricHeader
              metric={{
                key: 'postImpressions',
                title: 'Impressions',
                color: colors.secondary.default,
                icon: faEye,
              }}
            />
          </div>
          <SimpleGrid columns={3} gap={16} className="tw-mb-4">
            {IMPRESSIONS_POSTS.map((post, index) => (
              <StandardPostPreview
                key={index}
                {...post}
                medalRank={getMedalRankFromIndex(index)}
                classNames={{
                  root: 'tw-h-[432px] tw-w-full',
                }}
              />
            ))}
          </SimpleGrid>
        </div>
        <div>
          <div className="tw-mb-6 tw-flex tw-items-center">
            <MetricHeader
              metric={{
                key: 'reactions',
                title: 'Reactions',
                color: colors.turquoise.default,
                icon: faFaceSmileRelaxed,
              }}
            />
          </div>
          <SimpleGrid columns={3} gap={16} className="tw-mb-4">
            {REACTIONS_POSTS.map((post, index) => (
              <StandardPostPreview
                key={index}
                {...post}
                medalRank={getMedalRankFromIndex(index)}
                classNames={{
                  root: 'tw-h-[432px] tw-w-full',
                }}
              />
            ))}
          </SimpleGrid>
        </div>
      </div>
    </div>
  );
};

export default PostPerformanceDemoView;
